import { render, staticRenderFns } from "./V2ShareSelectionsErrorModal.vue?vue&type=template&id=52a5b7d4&scoped=true&"
import script from "./V2ShareSelectionsErrorModal.vue?vue&type=script&lang=js&"
export * from "./V2ShareSelectionsErrorModal.vue?vue&type=script&lang=js&"
import style0 from "./V2ShareSelectionsErrorModal.vue?vue&type=style&index=0&id=52a5b7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a5b7d4",
  null
  
)

export default component.exports